import Loader from './loader'
export default Loader



// WEBPACK FOOTER //
// ./src/components/loader/index.js